import { FunctionComponent } from "react";
import { X } from "react-feather";

interface WishingCardProps {
  data?: any;
  closeBirthdayModal: () => void;
}

const WishingCard: FunctionComponent<WishingCardProps> = ({
  data,
  closeBirthdayModal,
}) => {
  return (
    <div className="w-screen h-screen fixed top-0 left-0 z-50 flex flex-col items-center justify-center backdrop-filter backdrop-blur-sm p-4">
      <div className="wishcard w-4/5 lg:w-auto">
        <div className="wishCardDesc flex flex-col bg-black text-white rounded-lg relative overflow-hidden">
          <div className="flex-shrink-0 flex justify-end px-4 lg:px-12 pt-4">
            <X
              className="text-white/70 hover:text-white cursor-pointer transition-colors"
              size={28}
              onClick={() => closeBirthdayModal()}
            />
          </div>
          <div className="flex-1 min-h-0 overflow-y-auto flex flex-col items-center px-4 lg:px-12 pt-4 pb-16">
            <div className="text-sm lg:text-xl leading-7 text-center tracking-wide">
              On behalf of the entire company, <br />{" "}
              <span className="text-red-600 font-bold"> Kazam </span> wishes a
              very happy birthday to
            </div>
            <div
              className={`grid lg:grid-cols-${data.length || 1} gap-x-6 pt-16`}
            >
              {data.length > 0 &&
                data.map((d: any, i: number) => {
                  return (
                    <div className="flex flex-col items-center" key={i}>
                      <div className="w-28 h-28 rounded-full">
                        <img
                          src={d.profile_image}
                          alt=""
                          className="w-full h-full rounded-full"
                        />
                      </div>
                      <div className="text-sm lg:text-3xl font-bold mt-8 mb-1 text-white text-opacity-70">
                        {d.first_name + " " + d.last_name}
                      </div>
                      <div className="text-xs lg:text-sm text-gray-500">
                        {d.designation}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="absolute bottom-0 -right-28 -rotate-45 pointer-events-none">
            <iframe src="https://embed.lottiefiles.com/animation/105525"></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WishingCard;
